import React, { FC } from 'react';
import styles from './GoogleDriveIcon.scss';

export const GoogleDriveIcon: FC = () => <div className={styles.googleDriveIcon} />;
